import { createSelector } from "reselect";

import {
    makeSelectSfColumns,
    makeSelectSfColumnsRaw,
} from "app/pages/sales-intelligence/sub-modules/management/store/selectors/salesforce/exportSelectors";
import type { CrmColumnItem } from "app/pages/sales-intelligence/sub-modules/management/types";
import type { RootState } from "single-spa/store/types";

import { createCrmFieldOptionsSelector, selectSelectedJobObject } from "../../../store/selectors";
import type { CrmEnrichmentJobObject } from "../../../types/types";
import { ENRICHMENT_OBJECT_TO_EXPORT_NAME } from "../../../utils/enrichmentObjectToExportName";

const DEFAULT_COLUMNS: readonly CrmColumnItem[] = [];

const getExportNameForJobObject = (jobObject: CrmEnrichmentJobObject) => ENRICHMENT_OBJECT_TO_EXPORT_NAME[jobObject];

export const selectSfColumnsByJobObjectRaw = (state: RootState, jobObject?: CrmEnrichmentJobObject) => {
    if (!jobObject) {
        return DEFAULT_COLUMNS;
    }

    return makeSelectSfColumnsRaw(getExportNameForJobObject(jobObject))(state);
};

export const selectSfColumnsByJobObject = (state: RootState, jobObject?: CrmEnrichmentJobObject) => {
    if (!jobObject) {
        return DEFAULT_COLUMNS;
    }

    return makeSelectSfColumns(getExportNameForJobObject(jobObject))(state);
};

export const selectSfColumnsBySelectedJobObjectRaw = createSelector(
    [selectSelectedJobObject, (state: RootState) => state],
    (selectedJobObject, state) => {
        if (!selectedJobObject) {
            return DEFAULT_COLUMNS;
        }

        return selectSfColumnsByJobObjectRaw(state, selectedJobObject);
    },
);

export const selectSfColumnsBySelectedJobObject = createSelector(
    [selectSelectedJobObject, (state: RootState) => state],
    (selectedJobObject, state) => {
        if (!selectedJobObject) {
            return DEFAULT_COLUMNS;
        }

        return selectSfColumnsByJobObject(state, selectedJobObject);
    },
);

export const selectSfCrmFieldOptions = createCrmFieldOptionsSelector(selectSfColumnsBySelectedJobObjectRaw);
